module.exports = __webpack_public_path__ + "img/swpa.c75d5cc6.jpg";